import { Button, Icon, Modal } from "semantic-ui-react";

import DataJobErrorsTableV3 from "routes/data_tab/components/data_job_errors_table/DataJobErrorsTableV3";
import PageContainer from "components/PageContainer";
import { TABLE_PAGE_CONTAINER_HEIGHT } from "constants/Constants";

const ValidationReport = ({ dataJobId }) => {
  return (
    <Modal
      closeIcon
      size="fullscreen"
      trigger={
        <Button secondary compact size="tiny" style={{ margin: "0.3em 0 0" }}>
          <Icon name="eye" />
          View Errors
        </Button>
      }
    >
      <Modal.Header>Import Validation Report</Modal.Header>
      <Modal.Content>
        <PageContainer
          styles={{ height: TABLE_PAGE_CONTAINER_HEIGHT.FILE_TAB }}
        >
          <DataJobErrorsTableV3 dataJobId={dataJobId} />
        </PageContainer>
      </Modal.Content>
    </Modal>
  );
};

export default ValidationReport;
